"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundDateRangeField = BoundDateRangeField;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const inputs_1 = require("../inputs");
const utils_1 = require("../utils");
const defaultLabel_1 = require("../utils/defaultLabel");
/** Wraps `TextField` and binds it to a form field. */
function BoundDateRangeField(props) {
    const { field, onChange = (value) => field.set(value), label = (0, defaultLabel_1.defaultLabel)(field.key), onBlur, onFocus, onEnter, readOnly, ...others } = props;
    const testId = (0, utils_1.useTestIds)(props, field.key);
    return ((0, jsx_runtime_1.jsx)(mobx_react_1.Observer, { children: () => ((0, jsx_runtime_1.jsx)(inputs_1.DateRangeField, { label: label, value: field.value || undefined, onChange: (value) => {
                onChange(value);
                field.maybeAutoSave();
            }, errorMsg: field.touched ? field.errors.join(" ") : undefined, required: field.required, onBlur: () => {
                field.blur();
                (0, utils_1.maybeCall)(onBlur);
            }, onFocus: () => {
                field.focus();
                (0, utils_1.maybeCall)(onFocus);
            }, onEnter: () => {
                (0, utils_1.maybeCall)(onEnter);
                field.maybeAutoSave();
            }, readOnly: readOnly || field.readOnly, ...testId, ...others })) }));
}
